<mat-card
  matRipple
  (click)="navigate()"
  class="flex flex-col items-center cursor-pointer"
>
  <mat-icon
    class="text-primary"
    [fontIcon]="application.icon"
    style="font-size: 48px; width: 48px; height: 48px;"
  ></mat-icon>
  <div class="text-center">
    <h3 class="text-lg font-semibold">
      {{ application.name }}
    </h3>
    @if (application.description) {
      <p class="text-sm mt-1">
        {{ application.description }}
      </p>
    }
  </div>
</mat-card>
